import { application } from "../../../app"

import FormAutoSubmitController from "./auto_submit_controller"
application.register("design-system--form--auto-submit", FormAutoSubmitController)
